;(function () {
  var root = document.getElementById('lev-tgs');
  if (!root) return;

  var WEBHOOK = root.getAttribute('data-webhook') || 'https://n8n-lev.fly.dev/webhook/the-simple-gym';
  var ASSINATURA = root.getAttribute('data-assinatura') || 'https://lev-minhaconta.netlify.app/api/tsg/assinatura';
  var form = root.querySelector('[data-tgs-form]');
  var success = root.querySelector('[data-tgs-success]');
  var addressInfo = root.querySelector('[data-tgs-address]');
  var addressFields = root.querySelector('[data-tgs-address-fields]');
  var cpfInvalid = root.querySelector('[data-tgs-cpf-invalid]');
  var cpfNotFound = root.querySelector('[data-tgs-cpf-not-found]');
  var submitError = root.querySelector('[data-tgs-submit-error]');
  var submitButton = root.querySelector('[data-tgs-submit]');
  var submitLabel = root.querySelector('[data-tgs-submit-label]');
  var cpfInput = form.querySelector('[name="cpf"]');
  var privacyFace = root.querySelector('[data-tgs-privacy-face]');
  var meta = { atualizado_em: null, consultado_em: null };
  var membership = '';
  var cepFound = false;
  var cepTimer = null;
  var cpfTimer = null;
  var submitting = false;

  function digits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function maskCpf(value) {
    var d = digits(value).slice(0, 11);
    return d
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }

  function maskPhone(value) {
    var d = digits(value).slice(0, 11);
    if (d.length < 3) return d;
    if (d.length < 8) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }

  function maskCep(value) {
    var d = digits(value).slice(0, 8);
    if (d.length <= 5) return d;
    return d.slice(0, 5) + '-' + d.slice(5);
  }

  function isValidCpf(value) {
    var cpf = digits(value);
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    var sum = 0;
    var i;
    for (i = 0; i < 9; i += 1) sum += Number(cpf.charAt(i)) * (10 - i);
    var check = (sum * 10) % 11;
    if (check === 10) check = 0;
    if (check !== Number(cpf.charAt(9))) return false;
    sum = 0;
    for (i = 0; i < 10; i += 1) sum += Number(cpf.charAt(i)) * (11 - i);
    check = (sum * 10) % 11;
    if (check === 10) check = 0;
    return check === Number(cpf.charAt(10));
  }

  function field(name) {
    return form.querySelector('[name="' + name + '"]');
  }

  function data() {
    return {
      nome: field('nome').value.trim(),
      cpf: digits(field('cpf').value),
      whatsapp: digits(field('whatsapp').value),
      email: field('email').value.trim(),
      cep: digits(field('cep').value),
      endereco: field('endereco').value,
      cidade: field('cidade').value,
      estado: field('estado').value,
      numero: field('numero').value.trim(),
      complemento: field('complemento').value.trim(),
    };
  }

  function setCpfError(invalid, notFound) {
    cpfInput.classList.toggle('is-error', invalid || notFound);
    cpfInvalid.hidden = !invalid;
    cpfNotFound.hidden = !notFound;
  }

  function renderAddress(state, payload) {
    if (state === 'hidden') {
      addressInfo.hidden = true;
      addressFields.hidden = true;
      return;
    }
    addressInfo.hidden = false;
    if (state === 'loading') {
      addressInfo.textContent = 'Buscando endereco...';
      addressFields.hidden = true;
      return;
    }
    if (state === 'missing') {
      addressInfo.textContent = 'CEP não encontrado. Ajuste o CEP para continuar.';
      addressFields.hidden = true;
      return;
    }
    addressInfo.replaceChildren();
    [payload.endereco || '(Logradouro não vinculado a este CEP — conferir na hora da compra)', payload.cidade, payload.estado].forEach(function (line) {
      var span = document.createElement('span');
      span.textContent = line;
      addressInfo.appendChild(span);
    });
    addressFields.hidden = false;
  }

  function formValid() {
    var values = data();
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email);
    return Boolean(
      values.nome &&
        isValidCpf(values.cpf) &&
        membership === 'elegivel' &&
        values.whatsapp.length === 11 &&
        emailOk &&
        values.cep.length === 8 &&
        cepFound &&
        values.numero &&
        field('privacy').checked &&
        !submitting
    );
  }

  function refreshSubmit() {
    var valid = formValid();
    submitButton.disabled = !valid;
    submitButton.classList.toggle('is-valid', valid);
  }

  function lookupCep() {
    var cep = digits(field('cep').value);
    if (cep.length !== 8) {
      cepFound = false;
      field('endereco').value = '';
      field('cidade').value = '';
      field('estado').value = '';
      renderAddress('hidden');
      refreshSubmit();
      return;
    }
    renderAddress('loading');
    fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (response) {
        return response.json();
      })
      .then(function (body) {
        if (!body || body.erro) {
          cepFound = false;
          field('endereco').value = '';
          field('cidade').value = '';
          field('estado').value = '';
          renderAddress('missing');
        } else {
          cepFound = true;
          field('endereco').value = body.logradouro || '';
          field('cidade').value = body.localidade || '';
          field('estado').value = body.uf || '';
          renderAddress('found', {
            endereco: body.logradouro || '',
            cidade: body.localidade || '',
            estado: body.uf || '',
          });
        }
        refreshSubmit();
      })
      .catch(function () {
        cepFound = false;
        renderAddress('missing');
        refreshSubmit();
      });
  }

  function showMembershipUnavailable(message) {
    submitError.hidden = false;
    submitError.textContent = message || 'Não foi possível verificar sua assinatura agora. Tente novamente.';
  }

  function lookupMembership() {
    var cpf = digits(field('cpf').value);
    membership = '';
    submitError.hidden = true;
    meta.atualizado_em = null;
    meta.consultado_em = null;
    if (cpf.length !== 11) {
      setCpfError(false, false);
      refreshSubmit();
      return;
    }
    if (!isValidCpf(cpf)) {
      setCpfError(true, false);
      refreshSubmit();
      return;
    }
    setCpfError(false, false);
    fetch(ASSINATURA, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cpf: cpf }),
    })
      .then(function (response) {
        return response.json().then(function (body) {
          return { ok: response.ok, body: body };
        });
      })
      .then(function (result) {
        if (digits(field('cpf').value) !== cpf) return;
        var status = result.body && result.body.status;
        if (status === 'elegivel') {
          membership = 'elegivel';
          meta.atualizado_em = result.body.atualizado_em || null;
          meta.consultado_em = result.body.consultado_em || null;
          setCpfError(false, false);
        } else if (status === 'nao_elegivel' || status === 'cpf_invalido') {
          membership = 'nao_elegivel';
          setCpfError(false, true);
        } else {
          membership = 'indisponivel';
          setCpfError(false, false);
          showMembershipUnavailable(result.body && result.body.message);
        }
        refreshSubmit();
      })
      .catch(function () {
        if (digits(field('cpf').value) !== cpf) return;
        membership = 'indisponivel';
        setCpfError(false, false);
        showMembershipUnavailable();
        refreshSubmit();
      });
  }

  root.querySelectorAll('[data-tgs-scroll]').forEach(function (button) {
    button.addEventListener('click', function () {
      var target = document.getElementById('tsg-cadastro');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  field('cpf').addEventListener('input', function (event) {
    event.target.value = maskCpf(event.target.value);
    submitError.hidden = true;
    clearTimeout(cpfTimer);
    cpfTimer = setTimeout(lookupMembership, 400);
    refreshSubmit();
  });

  field('whatsapp').addEventListener('input', function (event) {
    event.target.value = maskPhone(event.target.value);
    refreshSubmit();
  });

  field('cep').addEventListener('input', function (event) {
    event.target.value = maskCep(event.target.value);
    clearTimeout(cepTimer);
    cepTimer = setTimeout(lookupCep, 300);
    refreshSubmit();
  });

  ['nome', 'email', 'numero', 'complemento', 'privacy'].forEach(function (name) {
    field(name).addEventListener('input', refreshSubmit);
    field(name).addEventListener('change', refreshSubmit);
  });

  field('privacy').addEventListener('change', function () {
    privacyFace.classList.toggle('is-checked', field('privacy').checked);
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!formValid()) return;
    submitting = true;
    submitError.hidden = true;
    submitLabel.textContent = 'Enviando...';
    refreshSubmit();
    var payload = data();
    fetch(WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        nome: payload.nome,
        cpf: payload.cpf,
        whatsapp: payload.whatsapp,
        email: payload.email,
        cep: payload.cep,
        endereco: payload.endereco,
        cidade: payload.cidade,
        estado: payload.estado,
        numero: payload.numero,
        complemento: payload.complemento,
        origem: 'the-simple-gym',
        campanha: 'the-simple-gym',
        simplegym_assinante: true,
        simplegym_atualizado_em: meta.atualizado_em,
        simplegym_consultado_em: meta.consultado_em,
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('webhook');
        form.hidden = true;
        success.hidden = false;
        if (window.matchMedia('(max-width: 1060px)').matches) {
          success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          document.getElementById('tsg-cadastro').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function () {
        submitting = false;
        submitLabel.textContent = 'Enviar';
        submitError.hidden = false;
        submitError.textContent = 'Erro ao enviar. Tente novamente.';
        refreshSubmit();
      });
  });

  var waves = root.querySelector('[data-tgs-waves]');
  var wavesTarget = 0;
  var wavesCurrent = 0;
  var wavesFrame = null;

  function wavesTick() {
    wavesFrame = null;
    wavesCurrent += (wavesTarget - wavesCurrent) * 0.03;
    if (Math.abs(wavesTarget - wavesCurrent) <= 0.02) wavesCurrent = wavesTarget;
    waves.style.transform = 'translate3d(0, ' + wavesCurrent + 'px, 0)';
    if (wavesCurrent !== wavesTarget) wavesFrame = requestAnimationFrame(wavesTick);
  }

  function wavesScroll() {
    if (!waves.offsetParent) return;
    wavesTarget = window.scrollY * -0.05;
    if (wavesFrame === null) wavesFrame = requestAnimationFrame(wavesTick);
  }

  if (waves && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.addEventListener('scroll', wavesScroll, { passive: true });
    window.addEventListener('resize', wavesScroll, { passive: true });
    wavesScroll();
  }

  refreshSubmit();
})();
